import { render, staticRenderFns } from "./Dialog_ClassInformation.vue?vue&type=template&id=5cf1d5b0&scoped=true&"
import script from "./Dialog_ClassInformation.vue?vue&type=script&lang=js&"
export * from "./Dialog_ClassInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf1d5b0",
  null
  
)

export default component.exports